
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/loan/mkk",
      function () {
        return require("private-next-pages/[city]/loan/mkk.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/loan/mkk"])
      });
    }
  